import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { ShineBorder } from './ShineBorder';

// Define content for each SIMULACRA location
const SIMULACRA_CONTENT = {
  SIMULACRA_01: {
    title: 'SIMULACRA_01',
    image: '/data/Town_01.jpg',
    description: 'Simulacra 01. The first instance of agentic living. Simmulating soon...',
    imageAlt: 'Town_01'
  },
  SIMULACRA_02: {
    title: 'SIMULACRA_02',
    image: '/data/Town_02.jpg',
    description: 'Simulacra 02. The second instance emerges in the heart of New York. Awakening imminent...',
    imageAlt: 'Town_02'
  },
  SIMULACRA_03: {
    title: 'SIMULACRA_03',
    image: '/data/Town_03.jpg',
    description: 'Simulacra 03. The third consciousness manifests in Istanbul. Convergence approaching...',
    imageAlt: 'Town_03'
  }
};

const Modal = ({ isOpen, onClose, simulacraId }) => {
  const content = SIMULACRA_CONTENT[simulacraId] || SIMULACRA_CONTENT.SIMULACRA_01;

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60" />
      
      <div className="relative w-full max-w-[800px] mx-4" onClick={handleModalClick}>
        <ShineBorder
          borderRadius={16}
          borderWidth={2}
          duration={8}
          color={["#A07CFE", "#FE8FB5", "#FFBE7B"]}
        >
          <div className="relative w-full rounded-2xl">
            <div className="absolute inset-0 bg-[#1a1a1a]/90 backdrop-blur-xl rounded-2xl" />
            <div className="relative w-full p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-medium tracking-wide text-white">{content.title}</h2>
                <button onClick={onClose} className="text-white/90 hover:text-white transition-colors">
                  <X size={24} />
                </button>
              </div>
              
              <div className="relative w-full rounded-xl overflow-hidden mb-6">
                <div className="aspect-[16/9] max-h-[400px]">
                  <img
                    src={content.image}
                    alt={content.imageAlt}
                    className="w-full h-full object-cover rounded-xl"
                  />
                </div>
              </div>
              
              <p className="text-lg text-white/95 leading-relaxed">
                {content.description}
              </p>
            </div>
          </div>
        </ShineBorder>
      </div>
    </div>
  );
};

export default Modal;